// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__2ciCE","title":"AfterBackImages_title__28HcE","images":"AfterBackImages_images__2GGVL"};